import { getInitialLetter } from "../../utils/string.js";
import Avatar_module_default from "./Avatar.module.js";
import { useIdColorHash } from "./useIdColorHash.js";
import classNames from "classnames";
import React, { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Avatar/Avatar.tsx
/**
* Some props warrant that the avatar become a button for accessibility purposes
* @param props Avatar props
* @returns whether the avatar should be a button or not
*/
function shouldBeAButton(props) {
	return !!(props.onClick || props.onKeyDown || props.onKeyUp);
}
/**
* Avatar component that will fallback to an initial letter over a coloured
* background if no source is provided or if the source has failed to load.
*/
var Avatar = forwardRef(function Avatar({ src, id, name = "", type = "round", className = "", size, style = {}, onError, ...props }, ref) {
	return React.createElement(shouldBeAButton(props) ? "button" : "span", {
		ref,
		role: "img",
		"aria-label": id,
		...props,
		"data-type": type,
		"data-color": useIdColorHash(id),
		className: classNames(Avatar_module_default.avatar, className, { [Avatar_module_default["avatar-imageless"]]: !src }),
		style: {
			...style,
			"--cpd-avatar-size": size
		}
	}, /* @__PURE__ */ jsx(React.Fragment, { children: !src ? getInitialLetter(name) : /* @__PURE__ */ jsx("img", {
		loading: "lazy",
		alt: "",
		src,
		referrerPolicy: "no-referrer",
		className: classNames(Avatar_module_default.image),
		"data-type": type,
		style,
		width: size,
		height: size,
		onError
	}) }));
});
//#endregion
export { Avatar };

//# sourceMappingURL=Avatar.js.map